export var initDomExtension = function () {
    var fadeIn = function (element, interval) {
        element.style.opacity = '0';
        element.style.display = "block";
        setTimeout(function () { return element.style.transition = "opacity linear " + interval / 1000 + "s"; }, 10);
        setTimeout(function () { return element.style.opacity = '1'; }, 20);
        return new Promise(function (resolve) {
            setTimeout(function () {
                element.style.transition = null;
                resolve();
            }, interval);
        });
    };
    var fadeOut = function (element, interval) {
        element.style.transition = "opacity linear " + interval / 1000 + "s";
        element.style.opacity = '1';
        setTimeout(function () { return element.style.opacity = '0'; });
        return new Promise(function (resolve) {
            setTimeout(function () {
                element.style.display = 'none';
                element.style.transition = null;
                resolve();
            }, interval);
        });
    };
    HTMLElement.prototype.fadeIn = function (interval) {
        if (interval === void 0) { interval = 500; }
        return (this instanceof HTMLElement) && fadeIn(this, interval);
    };
    HTMLElement.prototype.fadeOut = function (interval) {
        if (interval === void 0) { interval = 500; }
        return (this instanceof HTMLElement) && fadeOut(this, interval);
    };
    HTMLElement.prototype.hide = function () {
        this.style.display = 'none';
        return this;
    };
    HTMLElement.prototype.removeClass = function (className) {
        this.classList.remove(className);
        return this;
    };
    HTMLElement.prototype.addClass = function (className) {
        this.classList.add(className);
        return this;
    };
};
initDomExtension();
var getDomTopById = function (id) {
    var dom = document.getElementById(id);
    if (dom) {
        return dom.getBoundingClientRect().top;
    }
    return null;
};
export var getTopDomByIds = function (ids) {
    if (ids === void 0) { ids = []; }
    var list = ids.map(function (id) { return ({ id: id, top: getDomTopById(id) }); })
        .filter(function (i) { return i.top !== null; })
        .sort(function (i, j) { return i.top - j.top; });
    return list.length > 0 ? list[0].id : null;
};
